<template>
  <div class="monthly-car">
    <div>
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for="a_name">物业：</label>
            <el-select
              class="check-property"
              filterable
              clearable
              v-model.trim="search.propertyId"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for>车牌号:</label>
            <input
              clearable
              v-model="search.plateNumber"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
            />
          </div>
          <div class="form-group">
            <label for>手机号:</label>
            <input
              clearable
              v-model="search.phone"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="add_btn"
                @click="addOrEdit()"
              >
                添加
              </button>
            </span>
            <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
          <div class="form-group others">
            <button
              @click="downloadData"
              type="button"
              class="btn btn-primary"
              id="search_btn"
            >
              导出
            </button>
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="物业"
            prop="propertyName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车牌号"
            prop="plateNumber"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="手机号"
            prop="phone"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车主姓名"
            prop="userName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车辆编号"
            prop="attr1"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="注册时间"
            prop="crtTime"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="备注"
            prop="attr2"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="250px">
            <template slot-scope="scope">
              <button
                type="button"
                class="edit"
                @click="monthlyOrder(scope.row.id, scope.row.parentId)"
              >
                续费
              </button>
              <button
                type="button"
                class="edit"
                @click="getRentMonthUserIntervals(scope.row.id)"
              >
                开通时段
              </button>
              <button
                type="button"
                class="edit"
                @click="addOrEdit(scope.row.id)"
              >
                修改
              </button>
              <button class="delete" @click="del(scope.row.id)">删除</button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData"></Page>
    <!--添加或修改月租车用户-->
    <el-dialog
      title="添加或修改月租车用户"
      :visible.sync="monthlyUserDialogVisible"
      width="30%"
      :lock-scroll="false"
      :close-on-click-modal="false"
      @close="resetUserForm"
    >
      <el-form
        ref="userForm"
        class="user-form"
        :model="monthlyFormUser"
        label-width="80px"
        :rules="rules"
      >
        <div class="monthly-info">**月租车主信息</div>
        <el-form-item label="物业" prop="propertyId">
          <el-select
            class="check-property"
            filterable
            clearable
            v-model.trim="monthlyFormUser.propertyId"
          >
            <el-option
              v-for="item in propertyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车牌号" prop="plateNumber">
          <template>
            <el-input
              class="read-only"
              v-if="monthlyFormUser.id"
              v-model="monthlyFormUser.plateNumber"
              readonly
            ></el-input>
            <!-- <el-input v-else v-model="monthlyFormUser.plateNumber"></el-input> -->
            <div v-else>
              <div class="plateNumber">
                <div @click="dropdown" class="plateNumber-firstTwo">
                  <span>{{ plateNumber.first }}{{ plateNumber.second }}</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </div>
                <div>
                  <el-input v-model="monthlyFormUser.plateNumber"></el-input>
                </div>
              </div>
              <div class="plateNumber-firstTwo-spread" v-if="showSpreadTab">
                <table class="firstLetter" v-if="showFirstLetter">
                  <tr>
                    <td @click="getFirstLetter('京')">京</td>
                    <td @click="getFirstLetter('津')">津</td>
                    <td @click="getFirstLetter('沪')">沪</td>
                    <td @click="getFirstLetter('渝')">渝</td>
                    <td @click="getFirstLetter('冀')">冀</td>
                  </tr>
                  <tr>
                    <td @click="getFirstLetter('豫')">豫</td>
                    <td @click="getFirstLetter('鲁')">鲁</td>
                    <td @click="getFirstLetter('新')">新</td>
                    <td @click="getFirstLetter('苏')">苏</td>
                    <td @click="getFirstLetter('浙')">浙</td>
                  </tr>
                  <tr>
                    <td @click="getFirstLetter('赣')">赣</td>
                    <td @click="getFirstLetter('鄂')">鄂</td>
                    <td @click="getFirstLetter('桂')">桂</td>
                    <td @click="getFirstLetter('甘')">甘</td>
                    <td @click="getFirstLetter('晋')">晋</td>
                  </tr>
                  <tr>
                    <td @click="getFirstLetter('蒙')">蒙</td>
                    <td @click="getFirstLetter('陕')">陕</td>
                    <td @click="getFirstLetter('吉')">吉</td>
                    <td @click="getFirstLetter('闽')">闽</td>
                    <td @click="getFirstLetter('贵')">贵</td>
                  </tr>
                  <tr>
                    <td @click="getFirstLetter('粤')">粤</td>
                    <td @click="getFirstLetter('青')">青</td>
                    <td @click="getFirstLetter('藏')">藏</td>
                    <td @click="getFirstLetter('川')">川</td>
                    <td @click="getFirstLetter('宁')">宁</td>
                  </tr>
                  <tr>
                    <td @click="getFirstLetter('琼')">琼</td>
                    <td @click="getFirstLetter('黑')">黑</td>
                    <td @click="getFirstLetter('辽')">辽</td>
                    <td @click="getFirstLetter('皖')">皖</td>
                    <td @click="getFirstLetter('湘')">湘</td>
                  </tr>
                  <tr>
                    <td @click="getFirstLetter('黔')">黔</td>
                    <td @click="getFirstLetter('云')">云</td>
                    <td @click="getFirstLetter('使')">使</td>
                    <td @click="getFirstLetter('领')">领</td>
                  </tr>
                </table>

                <table class="secondLetter" v-if="showSecondLetter">
                  <tr>
                    <td @click="getSecondLetter('A')">A</td>
                    <td @click="getSecondLetter('B')">B</td>
                    <td @click="getSecondLetter('C')">C</td>
                    <td @click="getSecondLetter('D')">D</td>
                    <td @click="getSecondLetter('E')">E</td>
                  </tr>
                  <tr>
                    <td @click="getSecondLetter('F')">F</td>
                    <td @click="getSecondLetter('G')">G</td>
                    <td @click="getSecondLetter('H')">H</td>
                    <td @click="getSecondLetter('I')">I</td>
                    <td @click="getSecondLetter('J')">J</td>
                  </tr>
                  <tr>
                    <td @click="getSecondLetter('K')">K</td>
                    <td @click="getSecondLetter('L')">L</td>
                    <td @click="getSecondLetter('M')">M</td>
                    <td @click="getSecondLetter('N')">N</td>
                    <td @click="getSecondLetter('O')">O</td>
                  </tr>
                  <tr>
                    <td @click="getSecondLetter('P')">P</td>
                    <td @click="getSecondLetter('Q')">Q</td>
                    <td @click="getSecondLetter('R')">R</td>
                    <td @click="getSecondLetter('S')">S</td>
                    <td @click="getSecondLetter('T')">T</td>
                  </tr>
                  <tr>
                    <td @click="getSecondLetter('U')">U</td>
                    <td @click="getSecondLetter('V')">V</td>
                    <td @click="getSecondLetter('W')">W</td>
                    <td @click="getSecondLetter('X')">X</td>
                    <td @click="getSecondLetter('Y')">Y</td>
                  </tr>
                  <tr>
                    <td @click="getSecondLetter('Z')">Z</td>
                  </tr>
                </table>
              </div>
            </div>
          </template>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="monthlyFormUser.phone"></el-input>
        </el-form-item>
        <el-form-item label="车主姓名" prop="name">
          <el-input v-model="monthlyFormUser.name"></el-input>
        </el-form-item>
        <el-form-item label="车辆编号" prop="attr1">
          <el-input v-model="monthlyFormUser.attr1"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="attr2">
          <el-input type="textarea" v-model="monthlyFormUser.attr2"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
        <el-button @click="monthlyUserDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!--月租车用户续费-->
    <el-dialog
      title="续期"
      :visible.sync="monthlyOrderDialogVisible"
      width="30%"
      :lock-scroll="false"
      :close-on-click-modal="false"
      @close="resetRentMonthForm"
    >
      <el-form
        ref="rentMonthForm"
        :model="monthlyFormOrder"
        label-width="80px"
        :rules="rentMonthRules"
      >
        <el-form-item label="续费日期" prop="openDate" class="reset-input">
          <el-date-picker
            v-model="monthlyFormOrder.openDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="续费月数" prop="openMonth">
          <el-input v-model="monthlyFormOrder.openMonth"></el-input>
        </el-form-item>
        <el-form-item label="收费规则" prop="openCharge" class="reset-input">
          <el-select
            clearable
            v-model="monthlyFormOrder.openCharge"
            placeholder="请选择"
          >
            <el-option
              v-for="item in allMonthlyChargeRuleData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="道路名称" prop="parkings" class="reset-input">
          <el-select
            multiple
            clearable
            collapse-tags
            v-model="monthlyFormOrder.parkings"
            placeholder="请选择"
          >
            <el-option
              v-for="item in parkingsDataByProperty"
              :key="item.parkingId"
              :label="item.parkingName"
              :value="item.parkingId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="monthlyOrderTrue">确 定</el-button>
        <el-button @click="monthlyOrderDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!--付款二维码-->
    <div ref="imgDialog" class="imgDialog">
      <el-dialog
        title="扫码付款"
        :visible.sync="photoDialogVisible"
        width="400px"
        :lock-scroll="false"
        :close-on-click-modal="false"
      >
        <div id="qrcode"></div>
      </el-dialog>
    </div>
    <!--开通时段-->
    <el-dialog
      title="开通时段"
      :visible.sync="openingPeriodDialogVisible"
      width="600px"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <template>
        <ul v-if="openingPeriodData.length > 0">
          <li v-for="item in openingPeriodData" :key="item.id">
            <span>
              <span class="openingPeriod-info">道路名称:</span>
              <span class="openingPeriod-data">{{
                JSON.parse(item.parkingId).parkingName
              }}</span>
            </span>
            <span>
              <span class="openingPeriod-info">开始时间:</span>
              <span class="openingPeriod-data">{{ item.startDate }}</span>
            </span>
            <span>
              <span class="openingPeriod-info">结束时间:</span>
              <span class="openingPeriod-data">{{ item.endDate }}</span>
            </span>
          </li>
        </ul>
        <div v-else class="no-data">暂无数据</div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import AreaTree from "../../commons/areaTree";

import {
  rentMonthUserIntervals,
  getParkingsByProperty,
  monthlyUserAddOrEdit,
  monthlyUserList,
  allMonthlyChargeRule,
  monthlyUserOne,
  fetchPropertyList,
} from "@/api/url";

import Page from "../../commons/page";

// import Refresh from "../commons/refresh.vue";

import QRCode from "qrcodejs2"; // 引入qrcode

export default {
  data() {
    return {
      moduleName: "parking",
      monthlyUserDialogVisible: false,
      monthlyOrderDialogVisible: false,
      showFirstLetter: false,
      showSecondLetter: false,
      showSpreadTab: false,
      photoDialogVisible: false,
      openingPeriodDialogVisible: false,
      openingPeriodData: [],
      propertyList: [],

      plateNumber: {
        first: "粤",
        second: "B",
        remain: "",
      },
      allMonthlyChargeRuleData: [],
      monthlyFormUser: {
        id: "",
        name: "",
        plateNumber: "",
        phone: "",
        propertyId: null,
        attr1: "",
        attr2: "",
      },
      monthlyFormOrder: {
        id: "",
        openDate: "",
        openMonth: "",
        openCharge: "",

        parkings: [],
      },
      search: {
        pageSize: 10,
        pageNumber: 1,
        plateNumber: "",
        phone: "",
        propertyId: null,
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      tableListData: [],
      parkingsDataByProperty: [],
      rentMonthUserIntervalsData: [],
      rules: {
        propertyId: [
          {
            required: true,
            message: "请选择物业",
            trigger: ["blur", "change"],
          },
        ],
        name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        plateNumber: [
          { required: true, message: "请填写车牌", trigger: "blur" },
          // {
          // 	required: true,
          // 	trigger: 'blur',
          // 	validator:(rule,value,callback)=>{
          // 		if(value!= ""){
          //             if(( /^(((([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/).test(value) == false){
          //                 callback(new Error('车牌号输入有误'));
          //             }else{
          //                 callback();
          //             }
          //         }else{
          //             callback(new Error("请填写车牌号"));
          //         }
          // 	}
          // }
        ],

        phone: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value != "") {
                if (
                  /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(
                    value
                  ) == false
                ) {
                  callback(new Error("请填写正确手机号"));
                } else {
                  callback();
                }
              } else {
                callback(new Error("请填写手机号"));
              }
            },
          },
        ],
      },
      rentMonthRules: {
        openDate: [
          {
            required: true,
            trigger: ["blur", "change"],
            message:'请选择开通日期'
            // validator: (rule, value, callback) => {
            //   if (value != "") {
                // let date1 = new Date(value);
                // let date2 = new Date();
                // let timeDifference = false;
                // if (date1.getFullYear() > date2.getFullYear()) {
                //   timeDifference = true;
                // } else if (date1.getFullYear() == date2.getFullYear()) {
                //   if (date1.getMonth() > date2.getMonth()) {
                //     timeDifference = true;
                //   } else if (date1.getMonth() == date2.getMonth()) {
                //     if (date1.getDate() >= date2.getDate()) {
                //       timeDifference = true;
                //     }
                //   }
                // }
                // if (timeDifference) {
                //   callback();
                // } else {
                //   callback(new Error("选择日期小于当前日期"));
                // }
                
              // } else {
              //   callback(new Error("请选择开通日期"));
              // }
          //   },
          },
        ],
        openMonth: [
          { required: true, message: "请填写开通月数", trigger: "blur" },
        ],
        openCharge: [
          {
            required: true,
            message: "请选择收费规则",
            trigger: ["blur", "change"],
          },
        ],
        parkings: [
          {
            required: true,
            message: "请选择道路",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  filters: {
    handelIsRent(value) {
      let v;
      switch (value) {
        case 1:
          v = "有效";
          break;
        case 0:
          v = "无效";
          break;
        default:
          v = "无效";
      }
      return v;
    },
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.tableList(this.search.pageNumber);
    },

    tableList: function(curPage) {
      var _this = this;
      const { propertyId, pageSize, phone, plateNumber } = this.search;
      this.$get(monthlyUserList(), {
        parentId: propertyId ? propertyId : null,
        enabledFlag: "y",
        limit: pageSize,
        page: curPage,
        phone: phone ? phone : null,
        plateNumber: plateNumber ? plateNumber : null,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        const {
          data: { rows },
        } = data;
        _this.tableListData = rows.map((item) => {
          if (item.parentId && typeof JSON.parse(item.parentId) === "object") {
            item.propertyName = JSON.parse(item.parentId).name;
          }
          return item;
        });
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },
    addOrEdit(id) {
      this.monthlyFormUser.id = id;

      if (id) {
        this.monthlyUserDialogVisible = true;
        this.$get(monthlyUserOne() + "/" + this.monthlyFormUser.id).then(
          (data) => {
            let d = data.data;
            this.monthlyFormUser.plateNumber = d.plateNumber;
            this.monthlyFormUser.name = d.userName;
            this.monthlyFormUser.phone = d.phone;
            this.monthlyFormUser.propertyId = d.parentId;
            this.monthlyFormUser.attr1 = d.attr1;
            this.monthlyFormUser.attr2 = d.attr2;
          }
        );
      } else {
        this.monthlyUserDialogVisible = true;
        this.monthlyFormUser.plateNumber = "";
        this.monthlyFormUser.name = "";
        this.monthlyFormUser.phone = "";
        this.monthlyFormUser.propertyId = null;
        this.monthlyFormUser.attr1 = "";
        this.monthlyFormUser.attr2 = "";
      }
    },
    addOrEditTrue() {
      var _this = this;
      console.log(_this.monthlyFormUser.plateNumber);
      this.$refs["userForm"].validate(function(valid, noStri) {
        if (valid) {
          _this.monthlyUserDialogVisible = false;
          //添加月租车用户
          if (!_this.monthlyFormUser.id) {
            let plateNumber =
              _this.plateNumber.first +
              _this.plateNumber.second +
              _this.monthlyFormUser.plateNumber;
            _this
              .$postRequest(monthlyUserOne(), {
                parentId: _this.monthlyFormUser.propertyId,
                plateNumber: plateNumber,
                userName: _this.monthlyFormUser.name,
                phone: _this.monthlyFormUser.phone,
                attr1: _this.monthlyFormUser.attr1,
                attr2: _this.monthlyFormUser.attr2,
              })
              .then((data) => {
                if (data.status != 200) return;
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "添加成功!",
                });
                _this.search.pageNumber = 1;
                _this.tableList(_this.search.pageNumber);
              });
            //修改月租车用户
          } else {
            _this
              .$putRequest(monthlyUserOne() + "/" + _this.monthlyFormUser.id, {
                id: _this.monthlyFormUser.id,
                parentId: _this.monthlyFormUser.propertyId,
                plateNumber: _this.monthlyFormUser.plateNumber,
                userName: _this.monthlyFormUser.name,
                phone: _this.monthlyFormUser.phone,
                attr1: _this.monthlyFormUser.attr1,
                attr2: _this.monthlyFormUser.attr2,
              })
              .then((data) => {
                if (data.status != 200) return;
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "修改成功!",
                });
                _this.tableList(_this.curIndex);
              });
          }
        }
      });
    },
    searchList: function() {
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.userName = "";
    },
    del(id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function() {
          _this.$layer.close(index);
          _this.$deleteRequest(monthlyUserOne() + "/" + id).then((data) => {
            if (data.status != 200)
              return _this.$layer.msg("删除失败", { time: 1 });
            _this.$notify({
              type: "success",
              title: "成功",
              message: "删除成功!",
            });
            _this.tableList(_this.curIndex);
          });
        }
      );
    },
    monthlyOrder(id, road) {
      this.$router.push({path:'/main/vehicleManagement/monthlyCar/renewal',query:{recordId:id,road:road}})
      // this.monthlyFormOrder.openMonth = "";
      // this.monthlyFormOrder.openDate = "";
      // this.monthlyOrderDialogVisible = true;
      // this.monthlyFormOrder.id = id;
      // const parentId =
      //   parent && typeof JSON.parse(parent) === "object"
      //     ? JSON.parse(parent).id
      //     : null;
      // this.parkingsByProperty(parentId);
      // this.getAllMonthlyChargeRule(parentId);
    },
    monthlyOrderTrue() {
      var _this = this;
      console.log(_this.monthlyFormOrder.openCharge);
      this.$refs["rentMonthForm"].validate(function(valid, noStri) {
        if (valid) {
          _this.monthlyOrderDialogVisible = false;
          _this
            .$postRequest(monthlyUserAddOrEdit(), {
              id: _this.monthlyFormOrder.id,
              months: _this.monthlyFormOrder.openMonth,
              startTime: _this.monthlyFormOrder.openDate,
              chargeRuleId: _this.monthlyFormOrder.openCharge,
              parkingIds: _this.monthlyFormOrder.parkings,
            })
            .then((data) => {
              if (data.status != 200) return;
              _this.photoDialogVisible = true;
              _this.$nextTick(function() {
                document.getElementById("qrcode").innerHTML = "";
                _this.qrcode(data.data);
              });
            });
        }
      });
    },
    getAllMonthlyChargeRule(id) {
      let _this = this;
      this.$get(allMonthlyChargeRule(), {
        parentId: id,
      }).then((data) => {
        if (data.status != 200) return;
        _this.allMonthlyChargeRuleData = data.data;
      });
    },
    dropdown() {
      if (this.showSpreadTab) {
        this.showSpreadTab = false;
      } else {
        this.showSpreadTab = true;
      }
      this.showFirstLetter = true;
      this.showSecondLetter = false;
    },
    getFirstLetter(l) {
      this.plateNumber.first = l;
      this.showFirstLetter = false;
      this.showSecondLetter = true;
    },
    getSecondLetter(l) {
      this.plateNumber.second = l;
      this.showSpreadTab = false;
      this.showFirstLetter = false;
      this.showSecondLetter = false;
    },
    qrcode(url) {
      let qrcode = new QRCode("qrcode", {
        width: 360,
        height: 360,
        colorDark: "#000",
        colorLight: "#fff",
      });
      qrcode.clear(); //清除二维码
      qrcode.makeCode(url); //生成另一个新的二维码
    },
    openingPeriod(d) {
      this.openingPeriodDialogVisible = true;
    },
    parkingsByProperty(id) {
      var _this = this;
      this.$get(getParkingsByProperty(), {
        parentId: id,
      }).then((data) => {
        if (data.status != 200) {
          return;
        }
        _this.parkingsDataByProperty = data.data;
      });
    },
    resetUserForm() {
      this.$refs["userForm"].resetFields();
    },
    getRentMonthUserIntervals(userId) {
      let _this = this;
      this.openingPeriodDialogVisible = true;
      this.$get(rentMonthUserIntervals(), {
        userId,
      }).then((data) => {
        if (data.status != 200) return;
        _this.openingPeriodData = data.data;
      });
    },
    resetUserForm() {
      this.$refs["userForm"].resetFields();
    },
    resetRentMonthForm() {
      this.$refs["rentMonthForm"].resetFields();
    },
    getAllProperty() {
      this.$get(fetchPropertyList()).then((data) => {
        if (data.status === 200) {
          this.propertyList = data.data;
        }
      });
    },
    downloadData() {
      const { propertyId, pageSize, phone, plateNumber } = this.search;
      this.$downloadFileRequest(
        "/api/parking/rentMonthUser/rentMonthUserExport",
        {
          parentId: propertyId ? propertyId : null,
          enabledFlag: "y",
          phone: phone ? phone : null,
          plateNumber: plateNumber ? plateNumber : null,
        },
        "月租车辆"
      );
    },
  },

  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      // this.manager_btn_edit = this.elements['manager:btn_edit'];
      // this.manager_btn_delete = this.elements['manager:btn_delete'];
    },
  },
  components: {
    Page,
    // Refresh,
    AreaTree,
  },
  created: function() {
    // this.permiss;
  },
  mounted: function() {
    this.getAllProperty();
    this.tableList(this.search.pageNumber);
  },
  // watch: {
  //     elements: {
  //      	handler: function (val, oldVal) {
  //      		this.permiss;
  //      	},
  //       	deep: true
  //     }
  // }
};
</script>
<style scoped>
.monthly-info {
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
  color: #aaa;
  font-size: 16px;
}
.plateNumber {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.plateNumber-firstTwo {
  display: flex;
  justify-content: center;
  align-items: center;
}
.plateNumber div:first-child {
  width: 20%;
}
.plateNumber div:last-child {
  width: 100%;
}
.plateNumber-firstTwo-spread {
  position: absolute;
  z-index: 1000;
  background: white;
  box-shadow: 0 0 10px #ccc;
}
.plateNumber-firstTwo-spread table tr td {
  width: 40px;
  height: 40px;
  border: 1px solid #eee;
  color: #278cd8;
  text-align: center;
}
.plateNumber-firstTwo-spread table tr {
  border: 1px solid #ccc;
}
.plateNumber-firstTwo,
.plateNumber-firstTwo-spread table tr td {
  cursor: pointer;
}
ul li {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
}
.openingPeriod-info {
  display: inline-block;
  margin-right: 10px;
  color: #999;
}
/* .openingPeriod-data{
	font-size:18px;
} */
.no-data {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<style>
.read-only .el-input__inner {
  background-color: #eee !important;
}
.reset-input .el-date-editor,
.reset-input .el-select {
  width: 100% !important;
  max-width: 100% !important;
}
.user-form .el-select {
  width: 100%;
}
</style>
